<template>
  <div>
    <el-row><i class="el-icon-s-grid"></i>子码<el-button type="primary" icon="el-icon-back" size="mini" @click="goback()">返回</el-button><el-button type="primary" icon="el-icon-refresh" size="mini" @click="refresh()">刷新</el-button></el-row>
    <el-divider></el-divider>
    <el-row type="flex" justify="space-between">
      <el-col :span="4" v-if="qr_type == 1 || qr_type == 2">
      <el-upload
        ref = "uperweima"
        action="/api/main/upzimaf"
        accept="image/png,image/jpeg"
        :show-file-list="false"
        :limit="10"
        :file-list="fileList"
        :headers="upheaders"
        :data="updata"
        :multiple="true"
        :on-exceed="handleExceed"
        :on-success="upsuccess">
        <el-button type="primary" icon="el-icon-plus">添加图片</el-button>
      </el-upload>
      </el-col>
      <el-col :span="7" v-else-if="qr_type == 3">
      <el-button type="primary" icon="el-icon-plus" @click="handleljEdit()">添加链接</el-button>
      <el-button type="primary" icon="el-icon-plus" @click="pladdlj()">批量添加链接</el-button>
      </el-col>
      <el-col :span="7"  v-else-if="qr_type == 4">
      <el-button type="primary" icon="el-icon-plus" @click="handlewdEdit()">添加文档</el-button>
      </el-col>
      <el-col :span="7"  v-else-if="qr_type == 5">
      <el-button type="primary" icon="el-icon-plus" @click="handleklEdit()">添加口令</el-button>
      <el-button type="primary" icon="el-icon-plus" @click="pladdkl()">批量添加口令</el-button>
      </el-col>
      <el-col :span="12">
      <el-button icon="el-icon-video-play" @click="qiSel">启用</el-button>
      <el-button icon="el-icon-video-pause" @click="tingSel">停用</el-button>
      <el-button icon="el-icon-cpu" @click="yuzhiSel">修改频率</el-button>
      <el-button type="danger" icon="el-icon-delete" @click="delSel">删除</el-button>
      </el-col>
      <el-col :span="5">
      <el-radio-group v-model="radio1" @change="editstatus">
            <el-radio-button label="">所有</el-radio-button>
            <el-radio-button label="1">使用中</el-radio-button>
            <el-radio-button label="0">暂停</el-radio-button>
          </el-radio-group>
      </el-col>
    </el-row>
    <el-table highlight-current-row
      :data="tableData"
      style="width: 100%"
       @selection-change="handleSelectionChange">
      <el-table-column
        type="selection"
        width="55">
      </el-table-column>
      <el-table-column
        prop="xuhao"
        label="顺序"
        width="80">
        <template slot-scope="scope">
          <div>
            {{scope.row.xuhao}} <el-button type="text" size="small" icon="el-icon-edit" @click="editxuhao(scope.row.child_id,scope.row.xuhao)"></el-button>
          </div>
        </template>
      </el-table-column>
      <el-table-column
        prop="qrcode"
        label="内容"
        align="center"
        width="300">
          <template slot-scope="scope">
            <el-row type="flex" justify="center" v-if="scope.row.type == 1 || scope.row.type == 2">
              <el-col :span="10">
                  <el-image
                    style="width: 100px; height: 100px"
                    :src="zimaurl(scope.row.qrcode)"
                    fit="fill">
                  </el-image>
              </el-col>
              <el-col :span="14">
                标题：{{scope.row.title}}
                <el-button type="text" size="small" icon="el-icon-edit" @click="edittitle(scope.row.child_id,scope.row.title)"></el-button>
                <el-upload
                  action="/api/main/changezimaf"
                  accept="image/png,image/jpeg"
                  :headers="upheaders"
                  :data="{child_id: scope.row.child_id}"
                  :multiple="false"
                  :file-list="fileList"
                  :on-success="upsuccess1">
                  <el-button>更换二维码</el-button>
                </el-upload>
              </el-col>
            </el-row>
            <div v-else-if="scope.row.type == 3">
                <p>标题：{{scope.row.title}}</p>
                链接：{{scope.row.lianjie}} <el-button type="text" size="small" icon="el-icon-edit" @click="handleljEdit(scope.$index,scope.row)"></el-button>
            </div>
            <div v-else-if="scope.row.type == 4">
                {{scope.row.title}}<el-button type="text" size="small" icon="el-icon-edit" @click="handlewdEdit(scope.$index,scope.row)"></el-button>
            </div>
            <div v-else-if="scope.row.type == 5">
                <p>标题：{{scope.row.title}}</p>
                内容：{{scope.row.content}}<el-button type="text" size="small" icon="el-icon-edit" @click="handleklEdit(scope.$index,scope.row)"></el-button>
            </div>
          </template>
      </el-table-column>
      <el-table-column
        prop="yuzhi"
        align="center"
        label="自动切换频率">
        <template slot-scope="scope">
          <div>
              {{scope.row.yuzhi}} <el-button type="text" size="small" icon="el-icon-edit" @click="edityuzhi(scope.row.child_id,scope.row.yuzhi)"></el-button>
          </div>
        </template>
      </el-table-column>
      <!-- <el-table-column
        prop="type"
        align="center"
        label="类型">
        <template slot-scope="scope">
          <div>
            {{qrtype(scope.row.type)}}
          </div>
        </template>
      </el-table-column> -->
      <el-table-column
        prop="type"
        align="center"
        label="更新时间">
        <template slot-scope="scope">
          <div>
            {{scope.row.updated?scope.row.updated.substr(0,10):""}}
          </div>
        </template>
      </el-table-column>
      <el-table-column
        prop="zima_status"
        align="center"
        label="状态">
        <template slot-scope="scope">
          <div>
            {{scope.row.zima_status == 1 ? '正常' : '关闭'}}
          </div>
        </template>
      </el-table-column>
      <el-table-column
        align="center"
        label="本轮扫描/累计扫码">
        <template slot-scope="scope">
          <div>
            {{scope.row.fwl}}/{{scope.row.ljfwl}}
          </div>
        </template>
      </el-table-column>
      <el-table-column
        align="center"
        label="本轮识别/累计识别">
        <template slot-scope="scope">
          <div>
            {{scope.row.sbl}}/{{scope.row.ljsbl}}
          </div>
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页组件 -->
    <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
    <!-- 链接码编辑界面 -->
    <el-dialog :title="title" :visible.sync="lianjieFormVisible" width="30%" @click="closeljDialog">
      <el-form label-width="120px" :model="editljForm" :rules="rules" ref="editljForm">
        <el-form-item label="标题: " prop="title">
          <el-input size="small" v-model="editljForm.title" auto-complete="off" placeholder="请输入活码标题"></el-input>
        </el-form-item>
        <el-form-item label="链接: " prop="lianjie">
          <el-input size="small" v-model="editljForm.lianjie" auto-complete="off" placeholder="活码的跳转链接"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="closeljDialog">取消</el-button>
        <el-button size="small" type="primary" :loading="loading" class="title" @click="submitForm('editljForm','lianjie')">保存</el-button>
      </div>
    </el-dialog>
    <!-- 批量添加链接码界面 -->
    <el-dialog :title="pltitle" :visible.sync="pllianjieFormVisible" width="30%" @click="closeplljDialog">
      <el-form label-width="120px" :model="addplljForm" :rules="rules" ref="addplljForm">
        <el-form-item label="链接: " prop="neirong">
          <el-input type="textarea" :autosize="{ minRows: 10}" v-model="addplljForm.neirong" placeholder="活码的跳转链接, 每行一个"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="closeplljDialog">取消</el-button>
        <el-button size="small" type="primary" :loading="loading" class="title" @click="submitForm('addplljForm','pllianjie')">保存</el-button>
      </div>
    </el-dialog>
    <!-- 批量添加口令码界面 -->
    <el-dialog :title="pltitle" :visible.sync="plkoulingFormVisible" width="30%" @click="closeplklDialog">
      <el-form label-width="120px" :model="addplklForm" :rules="rules" ref="addplklForm">
        <el-form-item label="口令: " prop="neirong">
          <el-input type="textarea" :autosize="{ minRows: 10}" v-model="addplklForm.neirong" placeholder="活码的口令, 每行一个"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="closeplklDialog">取消</el-button>
        <el-button size="small" type="primary" :loading="loading" class="title" @click="submitForm('addplklForm','plkouling')">保存</el-button>
      </div>
    </el-dialog>
    <!-- 图文码编辑界面 -->
    <el-dialog :title="title" :visible.sync="wendangFormVisible" width="60rem" @click="closewdDialog">
      <el-form label-width="120px" :model="editwdForm" :rules="rules" ref="editwdForm">
        <el-form-item label="标题: " prop="title">
          <el-input size="small" v-model="editwdForm.title" auto-complete="off" placeholder="请输入活码标题"></el-input>
        </el-form-item>
        <el-form-item label="内容: " prop="content">
          <template>
              <div class="hello">
                <editor id="editor_id" height="500px" width="100%" :content="editwdForm.content" :filterMode="false"
                        pluginsPath="/static/kindeditor/plugins/"
                        :items="kingitems"
                        uploadJson="/main/uptuwen"
                        :loadStyleMode="false"
                        @on-content-change="onContentChange"></editor>
              </div>
          </template>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="closewdDialog">取消</el-button>
        <el-button size="small" type="primary" :loading="loading" class="title" @click="submitForm('editwdForm','wendang')">保存</el-button>
      </div>
    </el-dialog>
    <!-- 口令码编辑界面 -->
    <el-dialog :title="title" :visible.sync="koulingFormVisible" width="30%" @click="closeklDialog">
      <el-form label-width="120px" :model="editklForm" :rules="rules" ref="editklForm">
        <el-form-item label="标题: " prop="title">
          <el-input size="small" v-model="editklForm.title" auto-complete="off" placeholder="请输入活码标题"></el-input>
        </el-form-item>
        <el-form-item label="内容: " prop="content">
          <el-input type="textarea" v-model="editklForm.content" placeholder="粘贴或输入口令在这里……"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="closeklDialog">取消</el-button>
        <el-button size="small" type="primary" :loading="loading" class="title" @click="submitForm('editklForm','kouling')">保存</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  import { zimaList, zmtitleSave, zmxuhaoSave, zmyuzhiSave, zmDelsel, zmQisel, zmTingsel, zmYuzhisel, zmSave, plAddlj, plAddkl} from '../../api/userMG'
  import Pagination from '../../components/Pagination'

  export default {
    data() {
      return {
        editor: null,
        html: null,
        editorText: '',
        title: '添加',
        pltitle: '批量添加',
        loading: false, //是显示加载
        tableData: [],
        ids: {child_id:[]}, //子码ID合集
        fileList: [],
        multipleSelection: [],
        radio1:'',
        qr_id: '',
        lianjieFormVisible: false,
        pllianjieFormVisible: false,
        plkoulingFormVisible: false,
        wendangFormVisible: false,
        koulingFormVisible: false,
        kingitems:[
        'source', '|', 'undo', 'redo', '|', 'preview', 'print', 'template', 'code', 'cut', 'copy', 'paste',
        'plainpaste', 'wordpaste', '|', 'justifyleft', 'justifycenter', 'justifyright',
        'justifyfull', 'insertorderedlist', 'insertunorderedlist', 'indent', 'outdent', 'subscript',
        'superscript', 'clearhtml', 'quickformat', 'selectall', '|', 'fullscreen', '/',
        'formatblock', 'fontname', 'fontsize', '|', 'forecolor', 'hilitecolor', 'bold',
        'italic', 'underline', 'strikethrough', 'lineheight', 'removeformat', '|', 'image',
        'table', 'hr', 'emoticons', 'baidumap', 'pagebreak',
        'anchor', 'link', 'unlink', '|', 'about'
        ],
        updata: {
          qr_id: ''
        },
        // rules表单验证
        rules: {
          title: [
            { required: true, message: '请输入子码标题', trigger: 'blur' },
            { min: 3, max: 50, message: '子码标题长度在 3 到 50 个字符', trigger: 'blur' }
          ],
          neirong: [
            { required: true, message: '表单内容不能为空', trigger: 'blur' }
          ],
          content: [
            { required: true, message: '请输入文档码内容', trigger: 'blur' },
            { min: 2, message: '子码内容长度最小为2个字符', trigger: 'blur' }

          ],
        },
        editljForm: {
          child_id: '',
          title: '',
          lianjie: ''
        },
        addplljForm: {
          neirong: ''
        },
        addplklForm: {
          neirong: ''
        },
        editwdForm: {
          child_id: '',
          title: '',
          content: ''
        },
        editklForm: {
          child_id: '',
          title: '',
          content: ''
        },
        changedata: {
          child_id: ''
        },
        upheaders:{
          'ContentType':'multipart/form-data',
          'token': localStorage.getItem('token')
        },
        // 分页参数
        pageparm: {
          currentPage: 1,
          pageSize: 10,
          total: 10
        },
        formInline: {
          page: 1,
          limit: 10,
          qr_id: '',
          status: ''
        }
      }
    },
    // 注册组件
    components: {
      Pagination
    },
    methods: {
      onContentChange (val) {
            this.editwdForm.content = val
      },
      // 关闭链接编辑框
      closeljDialog() {
        this.lianjieFormVisible = false
      },
      // 关闭批量链接添加框
      closeplljDialog() {
        this.pllianjieFormVisible = false
      },
      // 关闭批量口令添加框
      closeplklDialog() {
        this.plkoulingFormVisible = false
      },
      // 关闭图文编辑框
      closewdDialog() {
        this.wendangFormVisible = false
      },
      // 关闭口令编辑框
      closeklDialog() {
        this.koulingFormVisible = false
      },
      //显示链接编辑界面
      handleljEdit: function(index, row) {
        this.lianjieFormVisible = true
        if (row != undefined && row != 'undefined') {
          this.title = '修改链接子码'
          this.editljForm.child_id = row.child_id
          this.editljForm.title= row.title
          this.editljForm.lianjie = row.lianjie
        } else {
          this.title = '创建链接子码'
          this.editljForm.child_id = ''
          this.editljForm.title = ''
          this.editljForm.lianjie = ''
        }
      },
      //显示批量添加链接界面
      pladdlj: function(index, row) {
        this.pllianjieFormVisible = true
      },
      //显示批量添加口令界面
      pladdkl: function(index, row) {
        this.plkoulingFormVisible = true
      },
      //显示文档编辑界面
      handlewdEdit: function(index, row) {
        this.wendangFormVisible = true
        if (row != undefined && row != 'undefined') {
          this.title = '编辑文档子码'
          this.editwdForm.child_id = row.child_id
          this.editwdForm.title= row.title
          this.editwdForm.content= row.content
        } else {
          this.title = '创建文档子码'
          this.editwdForm.child_id = ''
          this.editwdForm.title = ''
        }
      },
      //显示口令编辑界面
      handleklEdit: function(index, row) {
        this.koulingFormVisible = true
        if (row != undefined && row != 'undefined') {
          this.title = '编辑口令子码'
          this.editklForm.child_id = row.child_id
          this.editklForm.title= row.title
          this.editklForm.content= row.content
        } else {
          this.title = '创建口令子码'
          this.editklForm.child_id = ''
          this.editklForm.title = ''
          this.editklForm.content= ''
        }
      },
      handleExceed(files, fileList) {
        this.$message.warning(`当前限制选择 10 个文件，本次选择了 ${files.length} 个文件`);
      },
      handleSelectionChange(val) {
        this.ids = {child_id:[]}
        let Things = val
        for (var i = 0; i < Things.length; i++) {
          this.ids.child_id.push(Things[i]['child_id'])
        }
      },
      goback() {
        this.$router.go(-1);
      },
      refresh() {
        this.getdata(this.formInline)
      },
      //子码上传成功
      upsuccess(response, file, fileList){
        console.log(fileList)
        if(response.data.length == fileList.length + this.tableData.length){
          this.tableData = response.data
          this.$message.success("上传成功！")
          this.fileList = []
          this.getdata(this.formInline)
        }
      },
      //子码上传成功
      upsuccess1(response, file, fileList){
        if(response.code == '0'){
          this.tableData = response.data
          this.$message.success("上传成功！")
          this.fileList = []
          this.getdata(this.formInline)
        }
      },
      getdata(parameter){
        this.loading = true
        /***
         * 调用接口
         */
        zimaList(parameter)
          .then(res => {
            this.loading = false
            if (res.success == false) {
              this.$message({
                type: 'info',
                message: res.msg
              })
            } else {
              this.tableData = res.data
              // 分页赋值
              this.pageparm.currentPage = this.formInline.page
              this.pageparm.pageSize = this.formInline.limit
              this.pageparm.total =  parseInt(res.count)
            }
          })
          .catch(err => {
            this.loading = false
            this.$message.error('菜单加载失败，请稍后再试！')
          })
      },
      // 分页插件事件
      callFather(parm) {
        this.formInline.page = parm.currentPage
        this.formInline.limit = parm.pageSize
        this.getdata(this.formInline)
      },
      zimaurl(url){
        return this.$yuanUrl + url
      },
      //获取子码类型
      qrtype(type) {
        switch(type) {
          case "1":
          return "客服码"
          break
          case "2":
          return "群活码"
          break
          case "3":
          return "链接码"
          break
          case "4":
          return "文档码"
          break
          case "5":
          return "口令码"
          break
          default:
          return "未知"
        }
      },
      //修改客服码子码标题
      edittitle(child_id,title){
          this.$prompt('请输入子码名称', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            inputValue: title
          }).then(({ value }) => {
            zmtitleSave({child_id:child_id, title: value}).then(res=>{
              if(res.code == 1){
                this.$message({
                  type: 'success',
                  message: res.msg
                });
                this.getdata(this.formInline)
              }else{
                this.$message({
                  type: 'info',
                  message: res.msg
                });
              }
            }).catch(err=>{
              this.$message.error('菜单加载失败，请稍后再试！')
            })

          }).catch(() => {
            this.$message({
              type: 'info',
              message: '取消输入'
            });
          });
      },
      //修改子码阈值
      edityuzhi(child_id,yuzhi){
          this.$prompt('请输入扫码阈值', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            inputValue: yuzhi
          }).then(({ value }) => {
            zmyuzhiSave({child_id:child_id, yuzhi: value}).then(res=>{
              if(res.code == 1){
                this.$message({
                  type: 'success',
                  message: res.msg
                });
                this.getdata(this.formInline)
              }else{
                this.$message({
                  type: 'info',
                  message: res.msg
                });
              }
            }).catch(err=>{
              this.$message.error('菜单加载失败，请稍后再试！')
            })

          }).catch(() => {
            this.$message({
              type: 'info',
              message: '取消输入'
            });
          });
      },
      //修改子码序号
      editxuhao(child_id,xuhao){
          this.$prompt('请输入序号', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            inputValue: xuhao
          }).then(({ value }) => {
            console.log(value)
            zmxuhaoSave({child_id:child_id, xuhao: value}).then(res=>{
              if(res.code == 1){
                this.$message({
                  type: 'success',
                  message: res.msg
                });
                this.getdata(this.formInline)
              }else{
                this.$message({
                  type: 'info',
                  message: res.msg
                });
              }
            }).catch(err=>{
              this.$message.error('菜单加载失败，请稍后再试！')
            })

          }).catch(() => {

            this.$message({
              type: 'info',
              message: '取消输入'
            });
          });
      },
      //删除选择
      delSel(){
        if(this.ids.child_id.length > 0){
          this.$confirm('此操作将永久删除子码记录, 是否继续?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            zmDelsel(this.ids).then(res=>{
              if(res.code == 1){
                this.$message({
                  message: '成功删除' + res.count + '条记录',
                  type: 'success'
                });
                this.getdata(this.formInline);
              }else{
                this.$message({
                  message: '操作失败',
                  type: 'info'
                });
              }
            }).catch(()=>{
              this.$message.error('操作失败，请稍后再试！')
            });
          }).catch(() => {
            this.$message({
              type: 'info',
              message: '已取消删除'
            });
          });
        }else{
          this.$message({
            message: '未选择任何项目',
            type: 'warning'
          });
        }
      },
      //批量启用客服码子码
      qiSel(){
        if(this.ids.child_id.length > 0){
          this.$confirm('此操作将批量启用子码记录, 是否继续?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            zmQisel(this.ids).then(res=>{
              if(res.code == 1){
                this.$message({
                  message: '成功启用' + res.count + '条记录',
                  type: 'success'
                });
                this.getdata(this.formInline);
              }else{
                this.$message({
                  message: '操作失败',
                  type: 'info'
                });
              }
            }).catch(()=>{
              this.$message.error('操作失败，请稍后再试！')
            });
          }).catch(() => {
            this.$message({
              type: 'info',
              message: '已取消'
            });
          });
        }else{
          this.$message({
            message: '未选择任何项目',
            type: 'warning'
          });
        }
      },
      //批量停用客服码子码
      tingSel(){
        if(this.ids.child_id.length > 0){
          this.$confirm('此操作将批量停用子码记录, 是否继续?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            zmTingsel(this.ids).then(res=>{
              if(res.code == 1){
                this.$message({
                  message: '成功停用' + res.count + '条记录',
                  type: 'success'
                });
                this.getdata(this.formInline);
              }else{
                this.$message({
                  message: '操作失败',
                  type: 'info'
                });
              }
            }).catch(()=>{
              this.$message.error('操作失败，请稍后再试！')
            });
          }).catch(() => {
            this.$message({
              type: 'info',
              message: '已取消'
            });
          });
        }else{
          this.$message({
            message: '未选择任何项目',
            type: 'warning'
          });
        }
      },
      //批量修改客服码子码阈值
      yuzhiSel(){
        if(this.ids.child_id.length > 0){
            this.$prompt('请输入阈值', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              inputPattern: /(^[1-9]\d*$)/,
              inputErrorMessage: '请输入正整数'
            }).then(({ value }) => {
              Object.assign(this.ids,{yuzhi: value})  //给ids对象添加阈值数据
              zmYuzhisel(this.ids).then(res=>{
                if(res.code == 1){
                  this.$message({
                    type: 'success',
                    message: '成功修改' + res.count + '条记录',
                  });
                  this.getdata(this.formInline)
                }else{
                  this.$message({
                    type: 'info',
                    message: '操作失败'
                  });
                }
              }).catch(err=>{
                this.$message.error('操作失败，请稍后再试！')
              })

            }).catch(() => {
              this.$message({
                type: 'info',
                message: '取消输入'
              });
            });
        }else{
          this.$message({
            message: '未选择任何项目',
            type: 'warning'
          });
        }
      },
      editstatus(res){
        this.formInline.status = res
        console.log(this.formInline)
        this.getdata(this.formInline)
      },
      // 编辑、增加页面保存方法
      submitForm(editData,onetype) {
        console.log(this.qr_id)
        this.$refs[editData].validate(valid => {
          let data =null
          if (valid) {
            switch(onetype){
              case 'pllianjie':
                data =this.addplljForm
                break
              case 'plkouling':
                data =this.addplklForm
                break
              case 'lianjie':
                data =this.editljForm
                break
              case 'wendang':
                data =this.editwdForm
                break
              case 'kouling':
                data =this.editklForm
                break
            }
            data.qr_id = this.qr_id
            if(onetype == 'pllianjie'){
                plAddlj(data).then(res=>{
                  if (res.code == 1) {
                    this.pllianjieFormVisible = false
                    this.loading = false
                    this.getdata(this.formInline)
                    this.$message({
                      type: 'success',
                      message: '操作成功！'
                    })
                  } else {
                    this.$message({
                      type: 'info',
                      message: res.msg
                    })
                  }
                  this.addplljForm.neirong = ''
                }).catch(err=>{
                  this.loading = false
                  this.$message.error('操作失败，请稍后再试！')
                })
            }else if(onetype == 'plkouling'){
                plAddkl(data).then(res=>{
                  if (res.code == 1) {
                    this.plkoulingFormVisible = false
                    this.loading = false
                    this.getdata(this.formInline)
                    this.$message({
                      type: 'success',
                      message: '操作成功！'
                    })
                  } else {
                    this.$message({
                      type: 'info',
                      message: res.msg
                    })
                  }
                  this.addplklForm.neirong = ''
                }).catch(err=>{
                  this.loading = false
                  this.$message.error('操作失败，请稍后再试！')
                })
            } else {
                zmSave(data)
                  .then(res => {

                    this.lianjieFormVisible = false
                    this.wendangFormVisible = false
                    this.koulingFormVisible = false
                    this.loading = false
                    if (res.code == 1) {
                      this.getdata(this.formInline)
                      this.$message({
                        type: 'success',
                        message: '操作成功！'
                      })
                    } else {
                      this.$message({
                        type: 'info',
                        message: res.msg
                      })
                    }
                    this.editljForm.child_id = ''
                    this.editljForm.title = ''
                    this.editljForm.lianjie = ''
                    this.editklForm.child_id = ''
                    this.editklForm.title = ''
                    this.editklForm.content = ''
                  })
                  .catch(err => {
                    this.lianjieFormVisible = false
                    this.koulingFormVisible = false
                    this.loading = false
                    this.$message.error('操作失败，请稍后再试！')
                  })
          }
        } else {
          return false
        }
      })
      }
    },
    created() {
      window.myData = this
      this.updata.qr_id = this.$route.params.qr_id
      this.formInline.qr_id = this.$route.params.qr_id
      this.qr_id = this.$route.params.qr_id
      this.qr_type = this.$route.params.qr_type
      this.getdata(this.formInline)

    },
    mounted() {
    },
    beforeDestroy() {
        const editor = this.editor
        if (editor == null) return
        editor.destroy() // 组件销毁时，及时销毁编辑器
    }
  }
</script>

<style src="@wangeditor/editor/dist/css/style.css"></style>



// WEBPACK FOOTER //
// src/views/huoma/Child.vue